import HomeI18n from './Home/Home.i18n.en';
import AttemptI18n from './Attempt/Attempt.i18n.en';
import ReportsI18n from './Reports/Reports.i18n.en';
import ComponentsI18n from './Components/Components.i18n.en';
import CommonI18n from './Common.i18n.en';
import { ResourceViewerI18n } from '@insync-students-components/ResourceViewer/locales/ResourceViewer.i18n.en';
export const StudentAppI18nEn = {
  studentApp: {
    ...CommonI18n,
    ...HomeI18n,
    ...AttemptI18n,
    ...ReportsI18n,
    ...ComponentsI18n,
    ...ResourceViewerI18n
  }
};